import { MTMSettingsDataGrid } from '../management/MTMSettingsDataGrid';

export function MTMSettingsTab() {
  return (
    <div className="flex-col gap-4">
      <MTMSettingsDataGrid />
    </div>
  );
}
